(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-product-card-list"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  class YGProductCardList extends HTMLElement {
    constructor() {
      super();
      this.initSwiper();
    }

    initSwiper() {
      this.prevBtn = this.querySelector('.swiper-button-prev');
      this.nextBtn = this.querySelector('.swiper-button-next');

      this.swiper = new Swiper(this.querySelector('.swiper'), {
        navigation: {
          nextEl: this.nextBtn,
          prevEl: this.prevBtn,
        },
        pagination: {
          el: this.querySelector('.swiper-pagination'),
          type: "progressbar"
        },
        slidesPerView: 1,
        spaceBetween: 12,
        breakpoints: {
          700:{
            slidesPerView: 3,
            spaceBetween: 16,
          },
          1000: {
            slidesPerView: 4,
            spaceBetween: 16,
          }
        }
      });
    }
  }
  if(!customElements.get('yg-product-card-list')) {
    customElements.define('yg-product-card-list', YGProductCardList);
  }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-swiper-card"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('ollo-look-stage'))customElements.define('ollo-look-stage',class extends HTMLElement{
connectedCallback(){if(this.ac)return;this.ac=new AbortController();const o={signal:this.ac.signal};this.items=[...this.querySelectorAll('.ols-look')];if(!this.items.length)return;this.index=Math.min(2,this.items.length-1);const names=['Forest Friend','Snow Sweetie','Little Dragon','Cozy Bear','Giraffe'];const thumbs=this.querySelector('.ols-thumbs');thumbs.replaceChildren();this.buttons=this.items.map((el,i)=>{el.dataset.name=el.dataset.name.trim()||names[i]||'Look '+(i+1);el.setAttribute('aria-label',el.dataset.name);el.addEventListener('click',()=>{if(!this.suppress)this.select(i)},o);let b=document.createElement('button');b.type='button';b.className='ols-thumb';b.setAttribute('aria-label',el.dataset.name);let img=el.querySelector('img').cloneNode();img.removeAttribute('srcset');img.removeAttribute('sizes');img.src=el.querySelector('img').src.replace(/width=d+/,'width=160');b.append(img);b.addEventListener('click',()=>this.select(i),o);thumbs.append(b);return b});this.querySelector('.ols-prev').addEventListener('click',()=>this.select(this.index-1),o);this.querySelector('.ols-next').addEventListener('click',()=>this.select(this.index+1),o);let stage=this.querySelector('.ols-stage');stage.addEventListener('pointerdown',e=>{this.start={x:e.clientX,y:e.clientY}},o);stage.addEventListener('pointerup',e=>{if(!this.start)return;let x=e.clientX-this.start.x,y=e.clientY-this.start.y;this.start=null;if(Math.abs(x)>35&&Math.abs(x)>Math.abs(y)){this.suppress=true;this.select(this.index+(x<0?1:-1));setTimeout(()=>this.suppress=false,100)}},o);stage.addEventListener('pointercancel',()=>this.start=null,o);this.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.select(this.index+(e.key==='ArrowRight'?1:-1))}},o);this.select(this.index)}
select(i){let n=this.items.length;this.index=(i+n)%n;this.items.forEach((el,k)=>{let d=(k-this.index+n)%n;if(d>n/2)d-=n;el.style.transform='translateX(calc(-50% + '+d*78+'%)) scale('+(d===0?1:Math.abs(d)===1?.78:.60)+')';el.style.zIndex=5-Math.abs(d);el.style.opacity=Math.abs(d)>2?'0':d===0?'1':'.75';el.style.visibility=Math.abs(d)>2?'hidden':'visible';el.setAttribute('aria-pressed',String(k===this.index));this.buttons[k].setAttribute('aria-pressed',String(k===this.index))});this.querySelector('.ols-name').textContent=this.items[this.index].dataset.name}
disconnectedCallback(){this.ac?.abort();this.ac=null}
});


if (!customElements.get('ollo-expression-wheel')) {
  customElements.define('ollo-expression-wheel', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.items = [...this.querySelectorAll('.ow-item')];
      this.stage = this.querySelector('.ow-stage');
      this.main = this.querySelector('.ow-main');
      this.index = 0; this.rotation = 0; this.suppressUntil = 0;
      if (!this.items.length) return;
      this.step = 360 / this.items.length;
      this.items.forEach((item,i) => item.addEventListener('click',()=>{
        if (performance.now() > this.suppressUntil) this.select(i,false);
      },options));
      this.querySelectorAll('[data-step]').forEach(button=>{
        button.disabled = this.items.length < 2;
        button.addEventListener('click',()=>this.select(this.index+Number(button.dataset.step)),options);
      });
      this.addEventListener('keydown',e=>{
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
        e.preventDefault();
        this.select(e.key==='Home'?0:e.key==='End'?this.items.length-1:this.index+(e.key==='ArrowRight'?1:-1));
        this.items[this.index].focus({preventScroll:true});
      },options);
      this.stage.addEventListener('pointerdown',e=>{
        if (!e.isPrimary || e.button!==0 || this.items.length<2) return;
        this.drag={id:e.pointerId,x:e.clientX,y:e.clientY,rotation:this.rotation,active:false};
      },options);
      this.stage.addEventListener('pointermove',e=>{
        const d=this.drag;
        if(!d){
          if(e.pointerType!=='mouse')return;
          const rect=this.stage.getBoundingClientRect();
          const x=e.clientX-rect.left-rect.width/2,y=e.clientY-rect.top-rect.height/2;
          const radius=Math.hypot(x,y)/rect.width;
          if(radius<.27 || radius>.50)return;
          const angle=Math.atan2(y,x)*180/Math.PI+30-this.rotation;
          const nearest=((Math.round(angle/this.step)%this.items.length)+this.items.length)%this.items.length;
          if(nearest!==this.index)this.select(nearest,false);
          return;
        }
        if(d.id!==e.pointerId)return;
        const dx=e.clientX-d.x,dy=e.clientY-d.y;
        if(!d.active){
          if(Math.abs(dy)>Math.abs(dx) && Math.abs(dy)>8){this.drag=null;return;}
          if(Math.abs(dx)<8)return;
          d.active=true;this.stage.setPointerCapture(e.pointerId);this.classList.add('is-dragging');
        }
        this.rotation=d.rotation+dx/this.stage.clientWidth*240;this.position();
      },options);
      const finish=e=>{
        const d=this.drag;if(!d || d.id!==e.pointerId)return;
        this.drag=null;this.classList.remove('is-dragging');
        if(d.active){
          this.suppressUntil=performance.now()+350;
          this.select(Math.round(-this.rotation/this.step));
          if(this.stage.hasPointerCapture(e.pointerId))this.stage.releasePointerCapture(e.pointerId);
        }
      };
      this.stage.addEventListener('pointerup',finish,options);
      this.stage.addEventListener('pointercancel',finish,options);
      this.addEventListener('shopify:block:select',e=>{
        const i=this.items.findIndex(item=>item.dataset.blockId===e.detail.blockId);if(i>=0)this.select(i);
      },options);
      this.resize=new ResizeObserver(()=>this.position());this.resize.observe(this.stage);
      this.select(0);
    }
    position(){
      const radius=this.stage.clientWidth*.40;
      this.querySelector('.ow-sector').style.transform='rotate('+(this.index*this.step+this.rotation)+'deg)';
      this.items.forEach((item,i)=>{
        const a=(i*this.step+this.rotation-30)*Math.PI/180;
        item.style.transform='translate(-50%,-50%) translate('+Math.cos(a)*radius+'px,'+Math.sin(a)*radius+'px)';
      });
    }
    select(value,rotate=true){
      const n=this.items.length;this.index=((value%n)+n)%n;
      const target=-this.index*this.step;
      if(rotate)this.rotation+=((target-this.rotation+540)%360+360)%360-180;
      this.items.forEach((item,i)=>item.setAttribute('aria-pressed',String(i===this.index)));
      const item=this.items[this.index];
      if(this.main && this.main.getAttribute('src')!==item.dataset.image)this.main.src=item.dataset.image;
      if(this.main)this.main.alt=item.dataset.title;
      this.querySelector('.ow-title').textContent=item.dataset.title;
      
      this.position();
    }
    disconnectedCallback(){this.abort?.abort();this.abort=null;this.resize?.disconnect();}
  });
}

  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video-list"] && !Shopify.designMode) return;
  try {
    
  class YGVideoList extends YGUtils {
    constructor() {
      super();
      this.playVideo = this.playVideoFn.bind(this);
      this.currentPlayVideo = null
    }

    get videoList() {
      return this.querySelectorAll('yg-video.yg-video-box');
    }

    get currentVideo() {
      return this.querySelector('.swiper-slide-active yg-video.yg-video-box');
    }

    connectedCallback() {
      this.swiper = this.initSwiper(this);
      this.videoList.forEach(video => {
        video.addEventListener('mouseenter', this.playVideo);
      });
      this.swiper.on('slideChangeTransitionEnd', this.playVideo)
    }

    playVideoFn(event) {
      // event is an Event object, so get the target (yg-video element)
      const video = event.currentTarget || event.target || this.currentVideo;
      
      if (this.currentPlayVideo == video) return;
      this.currentPlayVideo = video
      
      this.videoList.forEach(v => {
        v.pauseVideo();
        if (v) {
          v.closest('.swiper-slide').classList.remove('current-play')
        }
      });

      if (video && typeof video.playVideo === 'function') {
        video.playVideo();
        video.closest('.swiper-slide').classList.add('current-play')
      }
    }
  }
  if (!window.customElements.get('yg-video-list')) {
    window.customElements.define('yg-video-list', YGVideoList)
  }

  } catch(e) { console.error(e); }
})();
})();
